export default "__VITE_PUBLIC_ASSET__3ec41074__"